export const designSystemKeys = {
  all: ["design-system"] as const,
  themes: ["design-system", "themes"] as const,
  theme: (id: string) => ["design-system", "theme", id] as const,
};
